module.exports = "../../static/img/headBg.437cbbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImage/headBg.png
// module id = z1xu
// module chunks = 36